const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const tracking = require('od-modules/utils/tracking.utils');
const tms = require('od-modules/utils/tag_management.utils');
const fetcher = require('./cached_fetcher');

const getPlatform = () => {
    if (Odigeo.SessionScope.flow === 'desktop') {
        return 'DESKTOP';
    } else {
        return Odigeo.Device.navigator.isNative() ? 'NATIVE' : 'MOBILE';
    }
};

const getDeviceOs = () => {
    const {isAndroid, isAndroidICS, isIOS} = Odigeo.Device.navigator;
    return isIOS ? 'IOS' : ( isAndroid || isAndroidICS ) ? 'ANDROID' : 'OTHERS';
};

module.exports = ({data = {}, basePath = '/', dispatch = () => {}}) => ({
    events: [],
    application: {
        session: Odigeo._.merge({
            currency: Odigeo.Utils.Currency.currencyCode,
        }, Odigeo.SessionScope),
        ab: Odigeo._.merge({}, websiteConfigCollection.getAB()),
        data,
        basePath,
        services: {
            bookingChangeRequest: Odigeo.Settings.getProperty('bookingChangeRequestServiceUrlFormatter'),
        },
        platform: getPlatform(),
        deviceOs: getDeviceOs(),
        clientInterface: websiteConfigCollection.getClientInterface(),
    },
    tracking,
    tms,
    fetcher,
    dispatch,
    formatDate: Odigeo.Utils.formatDate,
});
